import React from 'react';
import { useRecoilValue } from 'recoil';
import useWindowDimensions from "@helpers/hooks/windowDemensions";
import useDeliveryRange from "@helpers/hooks/useDeliveryRange";
import { imageFrameState } from '@atoms';

const DeliveryDateRange = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;
  const frameChoose = useRecoilValue(imageFrameState);
  const currentFrameType = frameChoose || localStorage.getItem("frameSelected") || "classic";
  const { mobileRange, desktopRange } = useDeliveryRange(currentFrameType);

  const dateRange = isMobile ? mobileRange : desktopRange;

  if (!dateRange) return null;

  return (
    <div className='delivery-review-mobile'>
      צפי משלוח <span style={{ fontWeight: '500' }}>{dateRange}</span>
    </div>
  );
};

export default DeliveryDateRange;
